export default class API { };

/**
 * 用户接口地址
 */
API.ROOT_URL = ROOT_URL
API.LOGIN_URL = ROOT_URL + '/#/login';
/**
 * BOT接口地址
 */
//API.APPID = 'c476a0173003';
//API.APPID = 'a3435a1241e8';
API.APPID = '';
API.APPNAME = '';
API.APPLIST = [];
API.CONTEXT_PATH = '';

API.APP_LIST = '/passport-webapi/apps';
API.APP_LIST2 = '/passport/webapi/apps/list';

API.DEVICE_LIST = API.CONTEXT_PATH + '/device/list';
API.DEVICE_EXPORT = API.CONTEXT_PATH + '/sn/export';

API.DEVICE_DETAIL = API.CONTEXT_PATH + '/device/detail';

API.DEVICE_DELETE = API.CONTEXT_PATH + '/device/delete';

API.DEVICE_ENABLE = API.CONTEXT_PATH + '/device/enable';

API.SN_MAKE_CONFIG = API.CONTEXT_PATH + '/device/sn/config';

API.SN_SAVE_CONFIG = API.CONTEXT_PATH + '/device/sn/saveconfig';

API.SN_MAKE = API.CONTEXT_PATH + '/device/sn/create';

API.SN_MAKE_LIST = API.CONTEXT_PATH + '/device/sn/createlist';

API.SN_MAKE_DETAIL = API.CONTEXT_PATH + '/sn/batchdetail';

API.SN_CHECK = API.CONTEXT_PATH + '/sn/checkbatch';

API.SN_DOWN_URL = API.CONTEXT_PATH + '/device/sn/downloadurl';

API.SN_SS_SUMMARY = API.CONTEXT_PATH + '/statistics/summary';

API.SN_SS_NEWACTIVE = API.CONTEXT_PATH + '/statistics/active';

API.SN_SS_LIVENESS = API.CONTEXT_PATH + '/statistics/liveness';

API.SN_SS_ADD = API.CONTEXT_PATH + '/statistics/ssadd';

API.SN_CHECK_LIST = API.CONTEXT_PATH + '/sn/checklist';

API.SN_MANUAL_MAKE = API.CONTEXT_PATH + '/sn/manualmake';

API.SN_CAN_MANUAL= API.CONTEXT_PATH + '/device/sn/canmanual';

API.DATA_POINT_ADD = API.CONTEXT_PATH + '/datap/add';

API.DATA_POINT_LIST = API.CONTEXT_PATH + '/datap/list';

API.DATA_POINT_DEL = API.CONTEXT_PATH + '/datap/del';

API.DATA_POINT_DETAIL = API.CONTEXT_PATH + '/datap/detail';

API.DATA_POINT_EDIT = API.CONTEXT_PATH + '/datap/edit';

API.DEVICE_DEBUG_INFO = API.CONTEXT_PATH + '/device/debug';

API.DEVICE_ATTR_SHOW = API.CONTEXT_PATH + '/device/showattr';


API.SS_ACTIVE_LOCATION = API.CONTEXT_PATH + '/statistics/activelocation';

API.SS_LIVENESS_LOCATION = API.CONTEXT_PATH + '/statistics/livenesslocation';

API.SS_REMAIN_DAY = API.CONTEXT_PATH + '/statistics/remainday';

API.SN_RULE_LIST = API.CONTEXT_PATH + '/sn/rulelist';
API.SN_RULE_SAVE = API.CONTEXT_PATH + '/sn/rulesave';

API.SN_RANGE = API.CONTEXT_PATH + '/device/sn/range';

API.DEVICE_BSN_LIST = API.CONTEXT_PATH + '/device/bsn/list';
API.DEVICE_BSN_UNBIND = API.CONTEXT_PATH + '/device/bsn/unbind';

API.DEVICE_SNTASK_LIST = API.CONTEXT_PATH + '/device/sn-task/list';
API.DEVICE_SNTASK_ACK = API.CONTEXT_PATH + '/device/sn-task/ack';
API.DEVICE_SNTASK_NEW = API.CONTEXT_PATH + '/device/sn-task/new';

/**
 * 获取APP列表
 */
//API.APP_LIST = '/passport-webapi/apps';
/**
 * 用户退出
 */
API.USER_LOGOUT = '/passport-webapi/logout';

// permission
API.PERMISSION_ACCOUNT_CREATE = '/passport-webapi/admin/user/add'
API.PERMISSION_ACCOUNT_RESET_PASSWD = '/passport-webapi/admin/user/reset-passport'
API.PERMISSION_ACCOUNT_LIST = '/passport-webapi/admin/user/list'
API.PERMISSION_SYSTEM_LIST = '/passport-webapi/admin/system/list'
API.PERMISSION_SYSTEM_EDIT = '/passport-webapi/admin/system/edit'
API.PERMISSION_SYSTEM_ADD = '/passport-webapi/admin/system/add'
API.PERMISSION_SYSTEM_SHOW = '/passport-webapi/admin/system/show'

API.PERMISSION_ROLE_LIST = '/passport-webapi/admin/role/list'
API.PERMISSION_ROLE_EDIT = '/passport-webapi/admin/role/edit'
API.PERMISSION_ROLE_SHOW = '/passport-webapi/admin/role/show'
API.PERMISSION_ROLE_ADD = '/passport-webapi/admin/role/add'
API.PERMISSION_ROLE_DEL = '/passport-webapi/admin/role/del'

API.PERMISSION_PERM_LIST = '/passport-webapi/admin/permission/list'
API.PERMISSION_PERM_ADD = '/passport-webapi/admin/permission/add'
API.PERMISSION_PERM_EDIT = '/passport-webapi/admin/permission/edit'
API.PERMISSION_PERM_SHOW = '/passport-webapi/admin/permission/show'
API.PERMISSION_PERM_DEL = '/passport-webapi/admin/permission/del'

API.PERMISSION_USERROLE_ADD = '/passport-webapi/admin/userrole/add'
API.PERMISSION_USERROLE_EDIT = '/passport-webapi/admin/userrole/edit'
API.PERMISSION_USERROLE_INFO = '/passport-webapi/admin/userrole/info'
API.PERMISSION_USERROLE_SHOW = '/passport-webapi/admin/userrole/show'
API.PERMISSION_USERROLE_DEL = '/passport-webapi/admin/userrole/del'

API.PERMISSION_MENU_ADD = '/passport-webapi/admin/menu/add'
API.PERMISSION_MENU_EDIT = '/passport-webapi/admin/menu/edit'
API.PERMISSION_MENU_SHOW = '/passport-webapi/admin/menu/show'
API.PERMISSION_MENU_LIST = '/passport-webapi/admin/menu/list'
API.PERMISSION_MENU_DEL = '/passport-webapi/admin/menu/del'

API.PERMISSION_ROLEMENU_LIST = '/passport-webapi/admin/rolemenu/list'
API.PERMISSION_ROLEMENU_ADD = '/passport-webapi/admin/rolemenu/add'

API.APPICATION_CREATE_APP = '/passport-webapi/apps/create'
API.APPICATION_APPLIST = '/passport-webapi/apps/list'

API.CURRENT_USER_INFO = '/passport-webapi/session'
API.CURRENT_USER_EDIT = '/passport-webapi/user/edit'
/**
 * 播放mp3文件
 */
API.MP3_PLAY = '/dictionary/web/other/mp3_unpackage'

/**
 * 导航菜单
 */
API.ROLE_MEUN = '/passport-webapi/menus';

API.OTA_SCOPE_LIST = '/ota/scope/list';

API.UPDATE_PACKAGE_LIST = '/ota/package/list';
API.UPDATE_PACKAGE_STORE = '/ota/package/save';
API.UPDATE_APP_SCOPE = '/ota/app-scopes'
API.UPDATE_VERSION_LIST = '/ota/version/list';
API.UPDATE_GET_VERSION_INFO = '/ota/version/info';
API.UPDATE_DELETE_VERSION = '/ota/version/delete';
API.UPDATE_VERSION_STORE = '/ota/version/save';
API.UPDATE_UPLOAD = '/ota/upload';
API.UPDATE_UPLOAD_INFO = '/ota/upload-info';
API.UPDATE_GET_PACKAGE_INFO = '/ota/package/info';
API.UPDATE_DELETE_PACKAGE = '/ota/package/delete';
API.UPDATE_DELETE_PACKAGE_DELTA = '/ota/delta/delete';
API.UPDATE_PACKAGE_DELTA_LIST = '/ota/delta/list';
API.UPDATE_PACKAGE_STORE_DELTA = '/ota/delta/save';
API.UPDATE_GET_PACKAGE_DELTA_INFO = '/ota/delta/info';
API.UPDATE_TASK_LIST = '/ota/task/list';
API.UPDATE_TASK_STORE = '/ota/task/save';
API.UPDATE_GET_TASK_INFO = '/ota/task/info';
API.UPDATE_DELETE_TASK = '/ota/task/delete';
API.UPDATE_GET_TASK_REPORT  = '/ota/get-task-report';
API.UPDATE_GET_REPORT  = '/ota/report';
API.UPDATE_GET_VERSION  = '/ota/client/versions';
API.UPDATE_DELTA_VERSIONS = '/ota/delta/versions';

API.AI_QUERY_LIST = '/query/list';



// WEBPACK FOOTER //
// ./src/config/api.js